<div [formGroup]="form" class="col-md-6 mx-auto mt-5">
    <div class="text-center mb-2">
        <h2 class="mt-3">Vous avez réservé sur le Pass Culture ?</h2>
        <img class="w-75 mb-4" src="assets/img/passculture.png" alt="">
        <label>Saisissez votre code contre-marque</label>
        <input (keyup)="handleKeyUp($event)" (input)="changeTextToUppercase('contremarque')"
            [ngClass]="{'border-danger':submitted && controls.contremarque.errors}"
            class="form-control w-75 mx-auto text-center bg-light-gray" type="text" formControlName="contremarque">
        <div class="text-danger mb-3"
            *ngIf="submitted && ( controls.contremarque.errors.maxlength || controls.contremarque.errors.minlength)">
            contremarque invalide</div>
        <div class="text-danger mb-3" *ngIf="submitted && controls.contremarque.errors.required==true">contremarque
            requise</div>
        <button (click)="onSubmit()" type="button" class="btn btn-studiomap mt-2 text-uppercase"><i class="fa fa-check"></i> confirmer
        </button>
    </div>
</div>